"use client";

import CodePanel from "@/components/CodeEditors/CodePanel";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { cn } from "@/lib/utils";
import {
  useAiContextStore,
  useEngSpecOpenedFile,
} from "@/store/zustand/aiContextStore";
import { usePrevious } from "@/utils/utils";
import { Copy, XIcon } from "lucide-react";
import React, { useEffect, useState } from "react";
import { Tooltip } from "react-tooltip";
import { toast } from "sonner";
import { EngSpecFileDiff } from "./EngSpec";

interface FileChangeDetailsProps {}

export const FileChangeDetails = React.memo(({}: FileChangeDetailsProps) => {
  const { file } = useEngSpecOpenedFile() as { file: EngSpecFileDiff };

  const setEngSpecOpenedFile = useAiContextStore(
    (state) => state.setEngSpecOpenedFile
  );

  const copy = (text: string, isCommand: boolean) => {
    navigator.clipboard.writeText(text);
    toast(`${isCommand ? "Command" : "File name"} Copied`);
  };

  return (
    <div
      className={cn(
        "flex flex-col bg-background px-4 pb-2 border-b border-b-seconday-100 grow w-full"
      )}
    >
      <div className="flex items-center align-center justify-between pt-5">
        <div className={cn("text-sm pb-1", !file?.termCommand && "hidden")}>
          {file?.termCommand
            ? file?.summary || "Command Summary"
            : "Code Change"}
        </div>
        <div
          className={cn(
            "border border-secondary-n-700 rounded-md text-2xs font-mono py-0.5 px-2 bg-secondary-n-950 text-secondary-n-400 break-all !text-white",
            {
              hidden: file?.termCommand,
            }
          )}
        >
          {file?.path || (file?.storyboardName ? "Create Storyboard" : "")}
        </div>
        <div
          onClick={() => {
            // @ts-expect-error TS2345
            setEngSpecOpenedFile(null, false);
          }}
        >
          <XIcon className="w-4 h-4 cursor-pointer text-secondary-800 hover:text-secondary-900 mr-1" />
        </div>
      </div>
      <div className={cn("flex flex-col grow", !file?.termCommand && "hidden")}>
        <div
          className={cn(
            "flex flex-row justify-between gap-3 items-center py-4 w-full"
          )}
        >
          <div
            className={cn(
              "border border-secondary-n-700 rounded-md text-2xs font-mono py-0.5 px-2 bg-secondary-n-950 text-secondary-n-400 break-all flex items-center gap-2 cursor-pointer hover:bg-secondary-n-900",
              {
                hidden: !file?.path && !file?.termCommand,
              }
            )}
            onClick={() =>
              // @ts-expect-error TS2345
              copy(file?.path || file?.termCommand, !!file?.termCommand)
            }
          >
            <Copy className="size-3 shrink-0 text-secondary-n-500" />
            {file?.path || file?.termCommand}
          </div>
        </div>
        <div className="grow" />
      </div>
      <div
        className={cn("flex flex-col grow pt-2", file?.termCommand && "hidden")}
      >
        <CodePanel />
      </div>
    </div>
  );
});
